/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-lines-per-function */
import React from "react";
import moment from "moment";
import { Link } from "@reach/router";
import classNames from "classnames";
import { Tooltip } from "@material-ui/core";
import { formatPhone } from "utils/phone";
import { getLanguageNameByCode } from "../../utils";
import SelectRow from "./select-row";
import SelectStage from "./select-stage";
import tableStyles from "./table.module.css";
import Star from "./star";
import { useInterestsTable } from "./table-context";

const renderUnitSizes = (interest: any) => [
  interest.unit_size_sro ? "SRO" : null,
  interest.unit_size_studio ? "Studio" : null,
  interest.unit_size_1br ? "1BR" : null,
  interest.unit_size_1br_den ? "1BR_DEN" : null,
  interest.unit_size_2br ? "2BR" : null,
  interest.unit_size_3br ? "3BR" : null,
  interest.unit_size_4br ? "4BR" : null,
  interest.unit_size_5br ? "5BR" : null,
  interest.unit_size_shared ? "Shared" : null,
]
  .filter(Boolean)
  .join(", ");

interface Props {
  interest: any;
  offset: number;
  hasStar: boolean;
  onStar: (bool: boolean) => void;
  slideoutEnabled: boolean;
  interestListObj: null | Record<string, string>;
  weightedPrefsEnabled: boolean;
}

const TableRow: React.FC<Props> = ({ interest, onStar, hasStar, offset, slideoutEnabled, interestListObj, weightedPrefsEnabled }) => {
  const applicantName = (interest.applicant_name || "").trim() || "N/A";
  const id = interest.id as string;
  const { selectedInterestIds: ids } = useInterestsTable();
  const isRowhighlighted = window.location.href.match(id) || ids.includes(id);

  return (
    <tr className={classNames({ [tableStyles.highlightedRow]: isRowhighlighted })}>
      <td>
        <SelectRow id={id} />
      </td>
      <td>{interest.position_number}</td>
      <td>
        <Star
          currentInterestID={id}
          hasStar={hasStar}
          onStar={onStar}
        />
      </td>
      <td className={tableStyles.content} style={{ maxWidth: "200px" }}>
        {interest.is_duplicate && (
          <span
            style={{
              background: "#2fb5c7",
              color: "white",
              padding: "1px 9px",
              fontSize: "12px",
              marginRight: "10px",
              marginLeft: "-2px",
            }}
          >
            Duplicate
          </span>
        )}

        <>
          {slideoutEnabled &&
            (
              <Link
                className="open-slideout"
                style={{
                  color: "#2fb5c7",
                  cursor: "pointer",
                }}
                to={`interests/${interest.id}/activity`}>
                {applicantName}
              </Link>
            )
          }

          {!slideoutEnabled && (
            <Link to={`/dash/manager/interest/${interest.id}/activity?offset=${offset}`}>
              {applicantName}
            </Link>)
          }

          {interest.pref_lang && interest.pref_lang !== "en" && (
            <span className="badge hc-badge">{getLanguageNameByCode(interest.pref_lang)}</span>
          )}

          {interest.skips > 0 && (
            <Tooltip title="Applicant Skips">
              <span className={`badge ${tableStyles.skipContainer}`}>
                {interest.skips} {interest.skips > 1 ? "skips" : "skip"}
              </span>
            </Tooltip>
          )}
        </>
      </td>
      {interestListObj && (<td style={{ padding: "3px 4px" }}>
        {interestListObj[interest.interest_list_id]}
      </td>)}

      <td style={{ padding: "3px 4px" }}>
        <SelectStage interest={interest} />
      </td>
      <td className={tableStyles.content} style={{ maxWidth: "96px" }}>
        <a href={`tel:${formatPhone(interest.applicant_phone)}`}>
          {formatPhone(interest.applicant_phone)}
        </a>
      </td>
      <td style={{ textAlign: "center" }}>{interest.household_count}</td>
      <td>{renderUnitSizes(interest)}</td>
      <td>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <span>${(interest.household_income || 0).toLocaleString()}</span>
          {(interest.household_receives_other_housing_assistance ||
            interest.household_has_housing_authority_voucher) && (
            <span className={`badge ${tableStyles.subsidyPill}`}>Subsidy</span>
          )}
        </div>
      </td>
      <td className={tableStyles.content} style={{ maxWidth: "96px", textAlign: "right" }}>
        {interest.submitted_at && moment(interest.submitted_at * 1000).format("MM/DD/YY h:mm A")}
        {weightedPrefsEnabled ? <span> || {interest.weight}</span> : ""}
      </td>
    </tr>
  );
};

export default TableRow;
